import {
	ADMINADDORUPDATECURRENCY_SUCCESS,
	ADMINADDORUPDATECURRENCY_FAILED,
	RESET_ADMINADDORUPDATECURRENCY,
	LOADING_ADMINADDORUPDATECURRENCY,
	NETWORK_ERROR_ADMINADDORUPDATECURRENCY
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATECURRENCY:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINADDORUPDATECURRENCY_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINADDORUPDATECURRENCY_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINADDORUPDATECURRENCY:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINADDORUPDATECURRENCY:
			return (state = initialState);
		default:
			return state;
	}
};
